import React from "react";
import "../../../utils/date";
import "./DatePicker.less";
import KeyBoardDatePickers from "../KeyboardDatePicker/DatePicker";
import { ShowToast, toastType } from "../../../utils/toast-service";

class DatePickerFromAndTo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CustomStartDate: props.startDate,
      CustomEndDate: props.endDate,
    };
    this.handleEvent = this.handleEvent.bind(this);
  }

  /**
   * date change event handler
   * @param {*} event
   * @param {*} picker
   */
  handleEvent(stateToUpdate) {
    this.setState(stateToUpdate, () => {
      const { CustomStartDate, CustomEndDate } = this.state;
      let message = "";

      //console.log(CustomStartDate);
      if (CustomStartDate === null || CustomStartDate === "null") {
        ShowToast("From Date is required", toastType.ERROR, 3000, 500);
        message = "From Date is required";
        if (this.props.onError != undefined) {
          this.props.onError(true, message);
        }
      } else if (CustomEndDate === null || CustomEndDate === "null") {
        ShowToast("To Date is required", toastType.ERROR, 3000, 500);
        message = "To Date is required";
        if (this.props.onError != undefined) {
          this.props.onError(true, message);
        }
      } else if (CustomStartDate ===  "Invalid date") {
        ShowToast("From Date is invalid", toastType.ERROR, 3000, 500);
        message = "From Date is invalid";
        if (this.props.onError != undefined) {
          this.props.onError(true, message);
        }
      } else if (CustomEndDate ===  "Invalid date") {
        ShowToast("To Date is invalid", toastType.ERROR, 3000, 500);
        message = "To Date is invalid";
        if (this.props.onError != undefined) {
          this.props.onError(true, message);
        }
      } else if (new Date(CustomEndDate) < new Date(CustomStartDate)) {
        ShowToast("To Date cannot be greater than From Date", toastType.ERROR, 3000, 500);
        message = "To Date cannot be greater than From Date";
        if (this.props.onError != undefined) {
          this.props.onError(true, message);
        }
      }else {
        this.props.onDateChange(CustomStartDate, CustomEndDate);
        if (this.props.onError != undefined) {
          this.props.onError(false, message);
        }
      }
    });
  }

  render() {
    const { CustomStartDate, CustomEndDate } = this.state;
    const {header}=this.props;
    return (
      <div className={"row center-xs"}>
        <div className={"col-xs-4"}>
          <KeyBoardDatePickers
            id={"fromDate"}
            valueDate={CustomStartDate}
            label={"From Date"}
            toolTip={header !== undefined? header+" From" :"From Date"}
            format={"MM/DD/yyyy"}
            required
            handleChange={date => this.handleEvent({ CustomStartDate: date })}
          />
        </div>
        <div className={"col-xs-4"}>
          <KeyBoardDatePickers
            id={"endDate"}
            valueDate={CustomEndDate}
            label={"To Date"}
            toolTip={header !== undefined? header+" To" :"To Date"}
            format={"MM/DD/yyyy"}
            minDate={CustomStartDate}
            required
            handleChange={date => this.handleEvent({ CustomEndDate: date })}
          />
        </div>
      </div>
    );
  }
}
export default DatePickerFromAndTo;
